module.exports = __webpack_public_path__ + "img/pizza-6.06fbd6a8.jpg";